export const types = {
  complete: 'complete',
  period: 'period',
};